import { render, staticRenderFns } from "./BizSupport.vue?vue&type=template&id=623fec9b&scoped=true"
import script from "./BizSupport.vue?vue&type=script&lang=js"
export * from "./BizSupport.vue?vue&type=script&lang=js"
import style0 from "./BizSupport.vue?vue&type=style&index=0&id=623fec9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fec9b",
  null
  
)

export default component.exports